// src/sectors/pilates/settings/activities/hooks/useActivities.js
import React from 'react';
import { activitiesApi } from '../activitiesApi';

export function useActivities({ open }) {
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [items, setItems] = React.useState([]);

  const fetchList = React.useCallback(async () => {
    try {
      setErr(null);
      setLoading(true);
      const res = await activitiesApi.list(); // ✅ GET
      setItems(Array.isArray(res) ? res : []);
    } catch (e) {
      console.error(e);
      setErr(e?.response?.data?.message || e?.message || 'Faaliyetler alınamadı.');
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (!open) return;
    fetchList();
  }, [open, fetchList]);

  const create = React.useCallback(async ({ name }) => {
    console.log('🟦 activitiesApi.create ->', name);
    return activitiesApi.create({ name }); // ✅ POST
  }, []);

  const update = React.useCallback(async (id, { name }) => {
    console.log('🟦 activitiesApi.update ->', id, name);
    return activitiesApi.update(id, { name }); // ✅ PUT
  }, []);

  const setActive = React.useCallback(async (id, active) => {
    console.log('🟦 activitiesApi.setActive ->', id, active);
    return activitiesApi.setActive(id, active); // ✅ PATCH
  }, []);
  // ✅ EKLE
  const remove = React.useCallback(async (id) => {
    console.log('🟥 activitiesApi.remove ->', id);
    return activitiesApi.remove(id);
  }, []);

  return { remove, loading, err, items, fetchList, create, update, setActive };
}
